import { Head, router } from '@inertiajs/react';
import { useEffect, useRef } from 'react';
import { ArcadeShowcase } from '@/components/arcade/arcade-showcase';
import type { ArcadeIntrosShow } from '@/types';

const ANIMATION_DELAY_MS = 100;
const ANIMATION_DURATION_S = 1.7;

export default function Show({ edition }: ArcadeIntrosShow) {
  const progressRef = useRef(0);

  useEffect(() => {
    let rafId: number;

    const timeoutId = setTimeout(() => {
      let startTime: number | null = null;

      const tick = (now: number) => {
        if (startTime === null) startTime = now;
        const elapsed = (now - startTime) / 1000;
        progressRef.current = Math.min(1, elapsed / ANIMATION_DURATION_S);
        if (progressRef.current < 1) {
          rafId = requestAnimationFrame(tick);
        }
      };

      rafId = requestAnimationFrame(tick);
    }, ANIMATION_DELAY_MS);

    return () => {
      clearTimeout(timeoutId);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      <Head title={edition.title}>
        <meta name="description" content={edition.description} />
        <meta name="keywords" content={edition.keywords.join(', ')} />
        <link rel="canonical" href={edition.canonicalPath} />
        <link
          rel="alternate"
          type="text/markdown"
          href={edition.markdownPath}
        />
      </Head>
      {/* app/(public)/26/arcade/layout.tsx wraps this whole tree in a black page. */}
      <div className="min-h-screen bg-black">
      <section
        className="relative h-dvh w-full overflow-hidden"
        style={{
          background:
            'radial-gradient(ellipse at 60% 40%, #2a2a2a 0%, #111111 45%, #000000 100%)',
        }}
      >
        <ArcadeShowcase
          scrollProgressRef={progressRef}
          editionSlug={edition.eventSlug}
          partnerLogo={edition.partnerLogo}
          cameraEasing={(t) => (t <= 0 ? 0 : t >= 1 ? 1 : 1 - 2 ** (-6 * t))}
          onStartPress={(player) => {
            if (player === 2) router.visit(edition.galleryHref);
          }}
        />
      </section>
      </div>
    </>
  );
}
